module.exports = __webpack_public_path__ + "img/popup_option3.b59386b.png";